<template>
	<item-filter :items="countries" :selected-item="selectedCountry" @filteredByItem="filterDemosByCountry"></item-filter>

	<div class="container mt-5">
		<div class="columns is-multiline">
			<add-card v-if="auth.state.isLoggedIn" column-class="column is-2" @click="openAdd"></add-card>
			<template v-for="(g, j) in demosPaginated" :key="j">
				<div class="column is-2 is-flex is-flex-direction-column is-justify-content-space-between is-relative">
					<Carousel :items-to-show="itemsToShow" :mouse-drag="false">
						<Slide v-for="image in g.image.src" :key="image.id">
							<figure class="image is-3by4" @click="openGameModal(g.image)">
								<img :src="image" :alt="g.image.alt" class="is-relative" />
							</figure>
						</Slide>

						<template #addons>
							<Navigation />
						</template>
					</Carousel>
					<owned-or-not :owned="g.own"></owned-or-not>
					<div class="admin-actions" v-if="g.id && auth.state.isLoggedIn">
						<button class="icon-button" title="Edit" @click.stop="openEdit(g)">
							<i class="fas fa-pen"></i>
						</button>
						<button class="icon-button icon-button-delete" title="Delete" @click.stop="onDelete(g)">
							<i class="fas fa-trash"></i>
						</button>
					</div>
				</div>
			</template>
		</div>
		<empty-hero v-if="demosPaginated.length === 0"></empty-hero>

		<game-modal :game="gameModalContent" v-if="showGameModal" @close-modal="showGameModal = false"></game-modal>

		<Transition name="fade">
			<back-to-top v-if="currentPage > 1"></back-to-top>
		</Transition>
	</div>
	<add-demo-modal
		:show="showAddModal"
		:editing-item="editingItem"
		:countries="countries"
		:on-submit="handleSubmit"
		@close="onModalClose"
	></add-demo-modal>
</template>

<script>
import COUNTRIES from '@/countries.js';
import DEMOS from '@/demos.js';
import ItemFilter from '@/components/ItemFilter.vue';
import GameModal from '@/components/GameModal.vue';
import OwnedOrNot from '@/components/OwnedOrNot.vue';
import BackToTop from '@/components/BackToTop.vue';
import EmptyHero from '@/components/EmptyHero.vue';
import AddCard from '@/components/AddCard.vue';
import AddDemoModal from '@/components/AddDemoModal.vue';
import auth from '@/auth.js';
import customItems from '@/customItems.js';
import { Carousel, Slide, Navigation } from 'vue3-carousel';
export default {
	name: 'DemosView',
	props: ['ownFilter'],
	components: { Carousel, Slide, Navigation, GameModal, ItemFilter, EmptyHero, OwnedOrNot, BackToTop, AddCard, AddDemoModal },
	data() {
		return {
			auth,
			countries: COUNTRIES.filter((c) =>
				['Australia', 'France', 'Finland', 'China', 'Germany', 'India', 'Italy', 'Netherlands', 'Spain', 'Portugal', 'UK', 'Russia', 'USA', 'Poland', 'Brazil', 'Czech'].includes(
					c.name
				)
			),
			itemsToShow: 1,
			showGameModal: false,
			gameModalContent: null,
			currentPage: 1,
			perPage: 18,
			showAddModal: false,
			editingItem: null,
		};
	},
	computed: {
		selectedCountry() {
			return this.$route.params.country || '';
		},
		demos() {
			return [...customItems.getItems('demos'), ...DEMOS];
		},
		filteredDemos() {
			return this.selectedCountry !== '' ? this.demos.filter((g) => g.country.includes(this.selectedCountry.toLowerCase())) : this.demos;
		},
		demosPaginated() {
			let ownFilteredDemos = this.ownFilter !== undefined ? this.filteredDemos.filter((g) => g.own === this.ownFilter) : this.filteredDemos;

			return ownFilteredDemos.slice(0, this.currentPage * this.perPage);
		},
	},
	methods: {
		filterDemosByCountry(c) {
			this.$router.push({ name: 'demos', params: { country: c || undefined } });
		},
		openGameModal(g) {
			this.gameModalContent = g;
			this.showGameModal = true;
		},
		handleScroll() {
			if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
				this.currentPage++;
			} else if (window.scrollY === 0) {
				this.currentPage = 1;
				if (window.innerHeight > 1080) {
					this.currentPage = 2;
				}
			}
		},
		openAdd() {
			this.editingItem = null;
			this.showAddModal = true;
		},
		openEdit(item) {
			this.editingItem = item;
			this.showAddModal = true;
		},
		onModalClose() {
			this.showAddModal = false;
			this.editingItem = null;
		},
		async handleSubmit({ isEdit, id, payload }) {
			if (isEdit) {
				return customItems.updateItem('demos', id, payload);
			}
			return customItems.addItem('demos', payload);
		},
		async onDelete(item) {
			if (!confirm('Delete this item?')) return;
			const result = await customItems.deleteItem('demos', item.id);
			if (!result.ok) {
				alert(result.error || 'Could not delete this item.');
			}
		},
	},
	created() {
		this.currentPage = 1;
		if (window.innerHeight > 1080) {
			this.currentPage = 2;
		}
		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped>
.column {
	background-color: #57462e;
	background-clip: content-box;
}
.image img {
	object-fit: cover !important;
	object-position: center !important;
}
.admin-actions {
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 20;
	display: flex;
	gap: 6px;
}
.icon-button {
	width: 26px;
	height: 26px;
	padding: 0;
	margin: 0;
	border: none;
	border-radius: 50%;
	background-color: rgba(0, 0, 0, 0.6);
	color: white;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.7rem;
}
.icon-button:hover {
	background-color: #48c78e;
	color: #131417;
}
.icon-button-delete:hover {
	background-color: #f14668;
	color: white;
}
</style>
